import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import CoursesList from '../../../components/CoursesList'
import WidthContainer from '../../../components/WidthContainer'

const RootContainer = styled(WidthContainer)`
	margin-top: 6rem;
	margin-bottom: 7rem;
`

function CoursesListSection({className}) {
	return <RootContainer id='list' className={className}>
		<CoursesList/>
	</RootContainer>
}

CoursesListSection.propTypes = {
	className: PropTypes.string,
}

CoursesListSection.defaultProps = {
	className: '',
}

export default CoursesListSection
